module.exports = __webpack_public_path__ + "static/media/icon-home.f7f9466a.svg";